'use client';

import { isString } from 'lodash';
import { useParams } from 'next/navigation';

import { BrowseParamNames } from '~/constants/BrowseParamNames';

export const useURLWorkspaceId = () => {
  const params = useParams();
  const value = params[BrowseParamNames.WorkspaceId];

  return isString(value) ? value : undefined;
};
